module.exports = __webpack_public_path__ + "static/media/appointment_accepted.43f459ab.svg";